// import Vue from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// import './permission'
// import elementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import videoPlayer from 'vue-video-player'
// import "video.js/dist/video-js.css";
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'
//
// Vue.use(videoPlayer)
// Vue.use(VueQuillEditor)
// Vue.config.productionTip = false
// Vue.use(elementUI)
//
// //EventBus事件中转
// Vue.prototype.$bus = new Vue()
//
// // 在Vue实例创建前添加
// if (!localStorage.getItem('isAuthenticated')) {
//   localStorage.setItem('isAuthenticated', 'false');
// }
//
// new Vue({
//   router,
//   store,
//   render: h => h(App)
// }).$mount('#app');
import './permission';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import elementUI from 'element-ui';
import { Scrollbar } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Pagination from "@/components/Pagination";

Vue.config.productionTip = false;
Vue.use(elementUI);
Vue.use(Scrollbar);

Vue.component('Pagination', Pagination)

// EventBus事件中转
Vue.prototype.$bus = new Vue();

// 在Vue实例创建前添加
if (!localStorage.getItem('isAuthenticated')) {
  localStorage.setItem('isAuthenticated', 'false');
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
